import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UseFormReturn } from "react-hook-form";
import { ProjectFormValues } from "./types";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

interface ProjectLeadFieldProps {
  form: UseFormReturn<ProjectFormValues>;
}

export const ProjectLeadField = ({ form }: ProjectLeadFieldProps) => {
  const { session } = useAuth();

  const { data: users, isLoading } = useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      if (!session) return [];
      const { data, error } = await supabase
        .from("profiles")
        .select("id, full_name, email");
      if (error) throw error;
      return data;
    },
    enabled: !!session,
  });

  return (
    <FormField
      control={form.control}
      name="project_lead_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Líder del Proyecto</FormLabel>
          <Select
            onValueChange={(value) => field.onChange(value === "unassigned" ? "" : value)}
            value={field.value || "unassigned"}
            disabled={isLoading}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Seleccionar líder del proyecto" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="unassigned">Sin asignar</SelectItem>
              {users?.map((user: any) => (
                <SelectItem key={user.id} value={user.id}>
                  {user.full_name || user.email}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
